(function() {
  const formatRechargeProducts = (rawProducts) => {
    return rawProducts.map(product => {
      const productData = Object.values(product)[0];
      return {
        id: productData.id,
        external_product_id: productData.external_product_id,
        in_recharge: productData.in_recharge,
        is_subscription_only: productData.is_subscription_only,
        subscription_options: productData.subscription_options,
        variants: productData.variants.map(variant => ({
          id: variant.id,
          price: variant.prices.unit_price,
          discounted_price: variant.prices.discounted_price,
          compare_at_price: variant.prices.compare_at_price,
          selling_plan_allocations: variant.selling_plan_allocations
        })),
        selling_plan_groups: productData.selling_plan_groups.map(group => ({
          id: group.selling_plan_group_id,
          subscription_product_id: group.subscription_product_id,
          selling_plans: group.selling_plans.map(plan => ({
            id: plan.selling_plan_id,
            name: plan.selling_plan_name,
            frequency: plan.order_interval_frequency,
            frequency_type: plan.order_interval_unit_type,
            discount_type: plan.price_adjustments_value_type,
            discount_value: plan.price_adjustments_value
          }))
        }))
      };
    });
  };

  const updateRechargeProductsScript = (products) => {
    let scriptTag = document.getElementById('recharge-products-data');
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = 'recharge-products-data';
      scriptTag.type = 'application/json';
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(products);
    
    // Dispatch event for any subscription-price elements that might exist
    window.dispatchEvent(new CustomEvent('recharge:products:loaded', { 
      detail: { products }
    }));
  };

  const initRechargeProducts = async () => {
    try {
      // Check if we already have the script tag with data
      const scriptTag = document.getElementById('recharge-products-data');
      if (scriptTag) {
        const products = JSON.parse(scriptTag.textContent);
        window.dispatchEvent(new CustomEvent('recharge:products:loaded', { 
          detail: { products }
        }));
        return;
      }

      // If no script tag, fetch from ReCharge API
      if (typeof ReChargeWidget !== 'undefined' && ReChargeWidget.api) {
        const result = await ReChargeWidget.api.fetchProducts();
        const formattedProducts = formatRechargeProducts(result);
        updateRechargeProductsScript(formattedProducts);
      }
    } catch (error) {
      console.error('Error initializing ReCharge products:', error);
    }
  };

  // Wait for ReChargeWidget to be available
  const waitForRecharge = (callback, maxAttempts = 10) => {
    let attempts = 0;
    
    const checkRecharge = () => {
      attempts++;
      
      if (typeof ReChargeWidget !== 'undefined' && ReChargeWidget.api) {
        callback();
      } else if (attempts < maxAttempts) {
        // Exponential backoff: wait time increases exponentially with each attempt
        const waitTime = Math.pow(2, attempts) * 100; // 200ms, 400ms, 800ms, 1600ms, etc.
        console.log(`ReCharge not available yet. Retrying in ${waitTime}ms (attempt ${attempts}/${maxAttempts})`);
        setTimeout(checkRecharge, waitTime);
      } else {
        console.warn(`Failed to load ReCharge after ${maxAttempts} attempts`);
      }
    };
    
    checkRecharge();
  };

  // Initialize on DOM ready and handle section updates
  document.addEventListener('DOMContentLoaded', () => {
    waitForRecharge(initRechargeProducts);
  });

  // Handle Shopify section updates
  document.addEventListener('shopify:section:load', () => {
    const scriptTag = document.getElementById('recharge-products-data');
    if (scriptTag) {
      try {
        const products = JSON.parse(scriptTag.textContent);
        window.dispatchEvent(new CustomEvent('recharge:products:loaded', { 
          detail: { products }
        }));
      } catch (error) {
        console.error('Error handling section update:', error);
      }
    } else {
      waitForRecharge(initRechargeProducts);
    }
  });
})(); 